import { MenuPoint, MenuPointCallbackAction } from '@agilox/ui-common';
import { MenuPointUrl } from '../enums/menupoint-url.enum';

export const planMenuPoints = {
	dashboard: {
		name: 'menu.dashboard',
		url: MenuPointUrl.DASHBOARD,
		icon: 'dashboard',
		roles: [],
	} as MenuPoint,
	mapEditor: {
		name: 'menu.map_editor',
		url: MenuPointUrl.MAP_EDITOR,
		icon: 'map',
		roles: [],
		submenus: [
			{
				name: 'map_editor.submenu.map_editor',
				url: MenuPointUrl.MAP_EDITOR,
				roles: [],
			},
			{
				name: 'map_editor.submenu.maps',
				url: MenuPointUrl.MAPS,
				roles: [],
			},
		],
	},
	aiWorkflows: {
		name: 'menu.ai_workflows',
		url: MenuPointUrl.AI_WORKFLOWS,
		icon: 'process',
		roles: [],
	} as MenuPoint,
	workflows: {
		name: 'menu.workflow_manager',
		url: MenuPointUrl.WORKFLOWS,
		icon: 'process',
		roles: [],
	} as MenuPoint,
	help: {
		name: 'menu.help',
		url: '',
		icon: 'o_quesmark',
		roles: [],
		position: 'bottom',
		callback: true,
		callbackAction: MenuPointCallbackAction.HELP,
	} as MenuPoint,
	logout: {
		name: 'general.logout',
		url: '',
		icon: 'logout',
		roles: [],
		position: 'bottom',
		callback: true,
		callbackAction: MenuPointCallbackAction.LOGOUT,
	} as MenuPoint,
};
